import { withStyles } from 'tss-react/mui';
import { layout } from '../tools/layout';
import { mui } from '../tools/mui';

const Button = withStyles(mui.Button, (theme) => ({
  root: {
    height: layout.pxToRem(32),
    lineHeight: 1,
  },
  outlined: {
    backgroundColor: theme.palette.white,
  },
  outlinedPrimary: {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white,
    },
  },
}));

export default Button;
